/**
 * Created By Elia Rohana on 1/9/19
 */
import CommandHandler from 'diagram-js/lib/command/CommandHandler';
import { Base } from 'diagram-js/lib/model';
import { connectionExpression } from '@ispm-shared/modules/bpmn/diagram-element-terms';
import Modeling from 'diagram-js/lib/features/modeling/Modeling';

export class AppendConditionExpressionHandler implements CommandHandler {

    constructor(private moddle, private modeling: Modeling) { }

    execute(context): Base[] {
        const newCondition = this.moddle.create(connectionExpression, { body: `${context.expression}`});
        context.condition = newCondition;
        return [newCondition];
    }

    postExecute(context): any {
        const connection = context.connection;
      context.condition.language = 'javascript';
      connection.conditionExpression = context.condition;
      this.modeling.updateProperties(connection, { conditionExpression: context.condition});
    }
}
